import React, { useEffect, useState } from "react";
import { Button, Card, Col, Divider, Row, Space, Tag, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import { allapiAction } from "@/Redux/common/action";
import Slider from "react-slick";
import Boxes3 from "./Boxes3";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { allapiAction } from "../../../Redux/common/action";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../Redux/common/url";
import PackageDis from "./PackageDis";
import "./Deshnoard1.css";
import {
  EditOutlined,
  IdcardOutlined,
  MailOutlined,
  PhoneOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
} from "@ant-design/icons";
const { Text, Title } = Typography;
function Deshboard1() {
  const dispatch = useDispatch();
  const [profileModal, setProfileModal] = useState(false);
  const [userProfile, setUserProfile] = useState({});

  const get_category_sale = useSelector((state) =>
    state?.allapi?.get_category_sale ? state?.allapi?.get_category_sale : [],
  );

  const get_profile = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {},
  );
  console.log(get_profile);

  const slider_list = useSelector((state) =>
    state?.allapi?.slider_list ? state?.allapi?.slider_list : {},
  );

  const slider = slider_list?.sliders ? slider_list?.sliders : [];
  const ad = slider_list?.ads ? slider_list?.ads : [];
  const banner = slider_list?.banner ? slider_list?.banner : [];
  const ads2 = [...ad].reverse();

  useEffect(() => {
    setUserProfile(get_profile);

    return () => {};
  }, [get_profile]);

  const profileModalShow = () => setProfileModal(true);
  const profileModalHide = () => setProfileModal(false);

  const router = useNavigate();

  const handleProfileData = (e) => {
    const { name, value } = e.target;
    setUserProfile({
      ...userProfile,
      [name]: value,
    });
  };

  async function submitProfileData() {
    if (!userProfile.fullName) {
      toast.error("Please enter full name!");
    } else if (!userProfile.email) {
      toast.error("Please enter email!");
    } else {
      await dispatch(allapiAction.updateUserProfile(userProfile));
      dispatch(allapiAction.getprofile());
      setProfileModal(false);
    }
  }

  useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
    dispatch(allapiAction.deshBoradDataUserData());
    dispatch(allapiAction.getprofile());
    dispatch(allapiAction.getsliderList({ page: "home" }));
    return () => {};
  }, []);

  var settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const data2 = [
    ["Year", "Sales", "Expenses"],
    ["Monday", 20000, 30000],
    ["Tuesday", 35000, 15000],
    ["Wednesday", 38000, 14000],
    ["Thursday", 25000, 35000],
    ["Friday", 34000, 22000],
    ["Saturday", 42000, 34000],
    ["Sunday", 18000, 38000],
  ];
  const data = get_category_sale;

  const options = {
    title: "Company Performance",
    curveType: "function",
    legend: { position: "bottom" },
  };

  let pageUrl = "https://psf.academy/referalsignup?ref=" + get_profile?.referId;
  let pageUrl2 =
    "https://psf.academy/referalsignup?ref=" +
    get_profile?.referId +
    "&club=right";

  function copy() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }
  function copy2() {
    const el = document.createElement("input");
    el.value = pageUrl2;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Your Referal link Copied!");

    // setstshareshow(false);
  }

  return (
    <div>
      <Row justify={"center"}>
        <Col lg={12} md={24} sm={24} xs={24} style={{ padding: "0 12px" }}>
          <Card
            className="profile-card-modern"
            style={{
              borderRadius: "15px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              overflow: "hidden",
              border: "none",
              background: "#fff",
            }}
            bodyStyle={{ padding: "24px" }}
          >
            <Row gutter={[24, 24]} align="middle">
              {/* Left Side: Avatar/Logo */}
              <Col xs={24} sm={6} style={{ textAlign: "center" }}>
                <div
                  style={{
                    padding: "10px",
                    background: "#f0f2f5",
                    borderRadius: "12px",
                    display: "inline-block",
                  }}
                >
                  <img
                    src="/img/logo.png"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "contain",
                    }}
                    alt="profile"
                  />
                </div>
              </Col>

              {/* Right Side: Quick Action Buttons */}
              <Col xs={24} sm={18}>
                <Space
                  direction="vertical"
                  size="small"
                  style={{ width: "100%" }}
                >
                  <Link
                    to="/branch"
                    className="btn-hover color-2 blink-text"
                    style={{
                      display: "block",
                      textAlign: "center",
                      borderRadius: "8px",
                      padding: "3px",
                    }}
                  >
                    🚀 Become a Distributor
                  </Link>

                  {get_profile?.isaraeDistibutor === "Active" &&
                    get_profile?.branchtype === "Distributor" && (
                      <Row gutter={[8, 8]}>
                        <Col span={12}>
                          <Link
                            to="/branch-for-team"
                            className="btn-hover color-2"
                            style={{ fontSize: "12px", padding: "5px" }}
                          >
                            Give Distributor
                          </Link>
                        </Col>
                        <Col span={12}>
                          <Link
                            to="/branch-for-team-advisor"
                            className="btn-hover color-2"
                            style={{ fontSize: "12px", padding: "5px" }}
                          >
                            Give Advisor
                          </Link>
                        </Col>
                      </Row>
                    )}
                </Space>
              </Col>

              <Divider style={{ margin: "12px 0" }} />

              {/* Profile Details Section */}
              <Col span={24}>
                <div
                  style={{
                    background: "#fafafa",
                    padding: "16px",
                    borderRadius: "12px",
                  }}
                >
                  <Row gutter={[16, 12]}>
                    <Col span={24}>
                      <Space>
                        <IdcardOutlined style={{ color: "#1890ff" }} />
                        <Text strong>UID:</Text>{" "}
                        <Text copyable>{get_profile?.referId}</Text>
                      </Space>
                    </Col>
                    <Col span={24}>
                      <Space>
                        <UserOutlined style={{ color: "#1890ff" }} />
                        <Text strong>Name:</Text>{" "}
                        <Text>{get_profile?.fullName}</Text>
                      </Space>
                    </Col>
                    <Col span={24}>
                      <Space>
                        <MailOutlined style={{ color: "#1890ff" }} />
                        <Text strong>Email:</Text>{" "}
                        <Text>{get_profile?.email}</Text>
                      </Space>
                    </Col>
                    <Col span={24}>
                      <Space>
                        <PhoneOutlined style={{ color: "#1890ff" }} />
                        <Text strong>Phone:</Text>{" "}
                        <Text>{get_profile?.phone}</Text>
                      </Space>
                    </Col>
                    <Col span={24}>
                      <Space>
                        <SafetyCertificateOutlined
                          style={{ color: "#52c41a" }}
                        />
                        <Text strong>Distibutor:</Text>
                        <Tag
                          color={
                            get_profile?.isaraeDistibutor === "Active"
                              ? "green"
                              : "red"
                          }
                        >
                          {get_profile?.isaraeDistibutor}
                        </Tag>
                      </Space>
                    </Col>
                  { get_profile?.isaraeDistibutor === "Active" &&  <Col span={24}>
                      <Space>
                        <SafetyCertificateOutlined
                          style={{ color: "#52c41a" }}
                        />
                        <Text strong>Distibutor Type :</Text>
                        <Tag
                          color={
                            get_profile?.isaraeDistibutor === "Active"
                              ? "green"
                              : "red"
                          }
                        >
                          {get_profile?.category}
                        </Tag>
                      </Space>
                    </Col>}
                  { get_profile?.isaraeDistibutor === "Active" &&  <Col span={24}>
                      <Space>
                        <SafetyCertificateOutlined
                          style={{ color: "#52c41a" }}
                        />
                        <Text strong>Distibutor To :</Text>
                        <Tag
                          color={
                            get_profile?.isaraeDistibutor === "Active"
                              ? "green"
                              : "red"
                          }
                        >
                          {get_profile?.subcategory}
                        </Tag>
                      </Space>
                    </Col>}
                  </Row>
                </div>
              </Col>

              {/* Bottom Update Button */}
              <Col span={24}>
                <Button
                  type="primary"
                  icon={<EditOutlined />}
                  block
                  size="large"
                  onClick={profileModalShow}
                  style={{
                    borderRadius: "8px",
                    height: "45px",
                    fontWeight: "bold",
                  }}
                >
                  Update Profile Details
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col lg={12} md={24} sm={24} xs={24}>
          <div className="">
            <div className="hometest">
              <Slider {...settings}>
                {slider &&
                  slider?.map((data, i) => {
                    return (
                      <div key={i}>
                        <a className="ps-banner__overlay" href="#">
                          <img
                            src={URL?.API_BASE_URL + data?.image}
                            alt={"slider-" + i}
                          />
                        </a>
                      </div>
                    );
                  })}
                {/* <div>
                  <a className="ps-banner__overlay" href="#">
                    <img src="/img/slider1.jpg" alt="" />
                  </a>
                </div>
                <div className="ps-banner bg--cover">
                  <a className="ps-banner__overlay" href="#">
                    <img src="/img/slider2.jpg" alt="" />
                  </a>
                </div>
                <div className="ps-banner bg--cover">
                  <a className="ps-banner__overlay" href="#">
                    <img src="/img/slider3.jpg" alt="" />
                  </a>
                </div>
                <div className="ps-banner bg--cover">
                  <a className="ps-banner__overlay" href="#">
                    <img src="/img/slider4.jpg" alt="" />
                  </a>
                </div> */}
              </Slider>
            </div>
          </div>
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          {/* <div className=" p-10">
            <Boxes3 />
          </div> */}
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <PackageDis />
        </Col>
      </Row>

      <Modal show={profileModal} onHide={profileModalHide} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Update Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card mx-auto">
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  name="fullName"
                  className="form-control"
                  placeholder="Enter full Name"
                  type="text"
                  value={userProfile.fullName}
                  onChange={handleProfileData}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  name="email"
                  className="form-control"
                  placeholder="Enter Email"
                  type="text"
                  value={userProfile.email}
                  onChange={handleProfileData}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={profileModalHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={submitProfileData}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Deshboard1;
